import {getEnv} from 'src/config/env';

export const SUPPORTED_LANGUAGES = ['vi', 'en'];

export const DEFAULT_LANGUAGE = 'vi';

export const LANGUAGE_STORAGE_KEY = 'dp_language';

// Feature flag: set REACT_APP_FF_ENABLE_I18N=false to turn translation off.
// When off the app is forced to Vietnamese (browser/localStorage ignored) and
// the language switcher is hidden from the header. Any value other than the
// string "false" keeps translation enabled (current behaviour).
export const I18N_ENABLED = getEnv('REACT_APP_FF_ENABLE_I18N') !== 'false';
